// Port of api/fuel/app/classes/filter/package/lists/listing/package/general.php
export default {
	run: function(pkg, local) {
		pkg.list = local.list
		pkg.edition = local.edition
		pkg.games = local.games
		return pkg
	}
}
